const envSettings = window as any;

export const Config = {
  APIEndpoint: envSettings.REACT_APP_API_ENDPOINT || "http://test",
  Environment: envSettings.ENVIRONMENT || "local",
  GMapsAPIKey: envSettings.REACT_APP_GOOGLE_MAP_API_KEY,
};
